import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { CacheProvider } from '@emotion/react';
import store from './Redux/Store';
import createCache from '@emotion/cache';
import { ConfirmProvider } from 'material-ui-confirm';
import { NoSsr } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';

export const muiCache = createCache({
  key: "mui",
  prepend: true,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <CacheProvider value={muiCache}>
      <NoSsr>
        <ConfirmProvider
          defaultOptions={{
            dialogProps: {
              PaperProps: {
                sx: {
                  width: 350,
                  margin: '0 auto',
                  padding: 2,
                  borderRadius: 2,
                  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  "& .MuiDialogTitle-root": {
                    padding: "0px",
                    fontSize: "24px",
                    textAlign: "center"
                  },
                  "& .MuiDialogContent-root": {
                    display: "none"
                  },
                  "& .MuiDialogActions-root": {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 1
                  }
                },
              },
            },
            confirmationButtonProps: {
              variant: 'contained',
              sx: {
                borderRadius: "30px",
                minWidth: "100px",
                backgroundColor: '#E77843',
                textTransform: "capitalize",
                color: '#fff',
                ':hover': { backgroundColor: '#E77843', boxShadow: "none" },
              },
            },
            confirmationText: 'Yes',
            cancellationText: 'No',
            cancellationButtonProps: {
              variant: 'outlined',
              sx: {
                borderRadius: "30px",
                minWidth: "100px",
                color: '#E77843',
                textTransform: "capitalize",
                borderColor: '#E77843',
                ':hover': { borderColor: '#E77843', backgroundColor: '#6836000a', },
              },
            },
          }}
        >
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfirmProvider>
      </NoSsr>
    </CacheProvider>
  </Provider>
);
